import type { FeatureDefinition } from "@growthbook/growthbook-react";

import type { AppFeatures } from "@/app/featureFlags/types";

export function mapToDefinitions(features: AppFeatures) {
  return Object.entries(features).reduce(
    (acc, [key, value]) => {
      return { ...acc, [key]: { defaultValue: value } };
    },
    {} as Record<string, FeatureDefinition>,
  );
}
